import { ref, onMounted } from 'vue'
import { useMapDrawingStore } from '@/stores/MapDrawingStore'
import { useGoogleMapHelpers } from '@/composables/useGoogleMapHelpers.js'

export const useSharedShape = () => {
  const mapDrawingStore = useMapDrawingStore()
  const googleMapHelpers = useGoogleMapHelpers()

  const sharedShape = ref(null)
  const bounds = ref(null)

  function getSharedShape() {
    const paramsStartIndex = window.location.href.indexOf('?')
    const urlParams = new URLSearchParams(window.location.href.substring(paramsStartIndex + 1))

    if (paramsStartIndex === -1) return false;

    const shapeType = urlParams.get('st');

    if (!shapeType || shapeType !== 'circle') return false;

    const paramCenterPoint = urlParams.get('cp');
    const paramPointsVisible = urlParams.get('pv');
    const paramRadius = urlParams.get('r');
    const paramShapeName = urlParams.get('sn');
    const paramFillColor = urlParams.get('fc');
    const paramFillOpacity = urlParams.get('fo');
    const paramStrokeColor = urlParams.get('sc');
    const paramStrokeWidth = urlParams.get('sw');
    const paramStrokeOpacity = urlParams.get('so');

    if (!paramCenterPoint || !paramRadius) return false;

    const centerPointParts = paramCenterPoint.split(',');
    const centerPointLat = parseFloat(centerPointParts[0]);
    const centerPointLon = parseFloat(centerPointParts[1]);
    const radius = parseFloat(paramRadius);

    if (shapeType === 'circle' && (isNaN(centerPointLat) || isNaN(centerPointLon) || isNaN(radius))) return false

    const centerPointLatLon = { lat: centerPointLat, lng: centerPointLon }
    const radiusLatLonNorth = googleMapHelpers.getLatLonAtDistance({ latLon: centerPointLatLon, distance: radius })
    const radiusLatLonSouth = googleMapHelpers.getLatLonAtDistance({ latLon: centerPointLatLon, distance: radius, heading: 180 })

    bounds.value = new google.maps.LatLngBounds()
    bounds.value.extend(radiusLatLonNorth)
    bounds.value.extend(radiusLatLonSouth)

    const shapeSettings = {};
    if (radius) shapeSettings.radius = radius
    if (paramFillColor) shapeSettings.fill = decodeURIComponent(paramFillColor);
    if (paramFillOpacity) shapeSettings.fillOpacity = parseFloat(paramFillOpacity);
    if (paramStrokeColor) shapeSettings.strokeColor = decodeURIComponent(paramStrokeColor);
    if (paramStrokeWidth) shapeSettings.strokeWidth = parseInt(paramStrokeWidth)
    if (paramStrokeOpacity) shapeSettings.strokeOpacity = parseFloat(paramStrokeOpacity)
    if (paramPointsVisible) shapeSettings.pointsVisible = paramPointsVisible === 'true'

    const shapeConfig = {
      type: encodeURIComponent(shapeType),
      latLons: [centerPointLatLon, { lat: radiusLatLonNorth.lat(), lng: radiusLatLonNorth.lng() }],
      shared: true,
      settings: shapeSettings
    }

    if (paramShapeName) {
      shapeConfig.name = decodeURIComponent(paramShapeName);
    }

    return shapeConfig
  }

  onMounted(() => {
    sharedShape.value = getSharedShape()

    if (!sharedShape.value) return

    mapDrawingStore.addShape(sharedShape.value.type, sharedShape.value)
    mapDrawingStore.deactivateDrawingMode()

    window.$JWX.map.fitBounds(bounds.value)
  })

  return {
    sharedShape,
    bounds
  }
}
